<!-- Progress bar sm-->
<div
  class="progress progress--sm"
  role="progressbar"
  aria-label="onboarding_progressbar"
  aria-valuenow="25"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <!-- los rangos serán 12.5%, 37.5%, 62.5%, 87.5%, 100% -->
  <div class="progress-bar" style="width: {{ progress }}%"></div>
  <!-- Steps -->
  <div class="progress__steps d-flex justify-content-between">
    @for (step of steps; track $index) {
      <div
        class="progress__item"
        [ngClass]="{
          'progress__item--active': step.active,
          'progress__item--success': step.success,
        }"
      >
        <p class="progress__info">{{ step.title }}</p>
      </div>
    }
  </div>
</div>
